import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { httpHeaderInterceptor } from './configs/http.interceptor';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes), provideClientHydration(withEventReplay()),
    provideHttpClient(withInterceptors([httpHeaderInterceptor])),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          // เปลี่ยนโทนหลักของ component ทั้งระบบ
          // ลองสลับเป็น 'blue', 'green', 'orange', 'purple' ฯลฯ ตามที่ธีมรองรับ
          primary: 'blue'
        }
      }
    })
  ]
};
